import { getTracking } from "./vendor/TrackingAdapter";

import type { TrackingState } from "./TrackingContext";
import type { StateCreator } from "zustand";

type StoreArgs = Parameters<StateCreator<TrackingState>>;
const tracker = getTracking("userpilot");

export function TrackingStore(...args: StoreArgs): TrackingState {
  const [set] = args;

  return {
    data: null,
    trackingAdapter: {
      initialize: (token) => {
        tracker.initialize(token);
      },
      onPageChange: (url) => {
        tracker.onPageChange(url);
      },
      onLogin: (user, company) => {
        tracker.onLogin(user, company);
        set({ data: { user, company } });
      },
      onEvent: (type, properties) => {
        tracker.onEvent(type, properties);
      },
      clearWebStorage: () => {
        tracker.clearWebStorage();
      },
    },
  };
}
